import React from 'react';
import { Award, Target, TrendingUp } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { mockCompanyInfo } from '../mock';

const About = () => {
  const valueIcons = {
    "Expertise": Award,
    "Sur-mesure": Target,
    "Résultats": TrendingUp
  };

  return (
    <section id="about" className="py-32 bg-gradient-to-br from-orange-50/30 via-white to-pink-50/30 relative">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-20 animate-fade-in">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">
              <span className="bg-gradient-to-r from-orange-500 via-pink-500 to-purple-600 bg-clip-text text-transparent">
                À Propos
              </span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              {mockCompanyInfo.description}
            </p>
          </div>

          {/* Company Image and Mission */}
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
            <div className="relative animate-fade-in">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
                <img
                  src="https://images.unsplash.com/photo-1763739527737-e3626d731072?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxjb25zdWx0aW5nJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc3MTM2MzY2Nnww&ixlib=rb-4.1.0&q=85"
                  alt="Professional Consulting"
                  className="w-full h-96 object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-purple-900/40 to-transparent"></div>
              </div>
            </div>

            <div className="space-y-6 animate-fade-in-right">
              <h3 className="text-3xl font-bold text-gray-900">Notre Mission</h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                {mockCompanyInfo.mission}
              </p>
              <div className="bg-white rounded-xl p-6 shadow-lg border-l-4 border-orange-500">
                <p className="text-gray-700 italic">
                  "{mockCompanyInfo.tagline}"
                </p>
              </div>
            </div>
          </div>

          {/* Values */}
          <div className="mb-20">
            <h3 className="text-3xl font-bold text-center mb-12 text-gray-900">Nos Valeurs</h3>
            <div className="grid md:grid-cols-3 gap-10">
              {mockCompanyInfo.values.map((value, index) => {
                const Icon = valueIcons[value.title];
                return (
                  <Card
                    key={index}
                    className="group hover:shadow-2xl transition-all duration-500 border-2 hover:border-orange-200 transform hover:-translate-y-2 animate-fade-in"
                    style={{ animationDelay: `${index * 150}ms` }}
                  >
                    <CardContent className="pt-6 text-center">
                      <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-pink-500 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                        <Icon className="w-8 h-8 text-white" />
                      </div>
                      <h4 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-orange-600 transition-colors">
                        {value.title}
                      </h4>
                      <p className="text-gray-600 leading-relaxed">
                        {value.description}
                      </p>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </div>

          {/* Company Info */}
          <div className="bg-white rounded-2xl shadow-xl p-10 text-center border-t-4 border-orange-500">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">{mockCompanyInfo.name}</h3>
            <p className="text-gray-600 mb-6">SIREN: {mockCompanyInfo.siren}</p>
            <div className="flex flex-wrap justify-center gap-8">
              {mockCompanyInfo.stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-4xl font-bold bg-gradient-to-r from-orange-500 via-pink-500 to-purple-600 bg-clip-text text-transparent">
                    {stat.value}
                  </div>
                  <div className="text-sm text-gray-600 mt-2">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom wave separator */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path d="M0 0L60 10C120 20 240 40 360 46.7C480 53 600 47 720 43.3C840 40 960 40 1080 46.7C1200 53 1320 67 1380 73.3L1440 80V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V0Z" fill="rgb(250 245 255)"/>
        </svg>
      </div>
    </section>
  );
};

export default About;
